import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';

import * as MapaBaseActions from '../../actions/';
import { MapaService } from 'src/app/services/SicarMap/MapaService.service';
import { FeactureService } from 'src/app/services/SicarMap/FeactureService.service';


@Injectable()
export class MapaBaseEffects {

    constructor(
      private actions$: Actions,
      private MapaBaseService: MapaService,
      private router: Router,
      private ServicioFeature: FeactureService
    ) {}

    @Effect()
    GetMapaBase$: Observable<any> = this.actions$.pipe(
      ofType(MapaBaseActions.MapaBaseActionTypes.GET_MAPABASE),
          switchMap( ( action: MapaBaseActions.GetMapaBase) => {
            return this.MapaBaseService.getMapaBaseComplete(action.contenedor).pipe(
              map((Mapa:{ [key: string]: boolean; }) => {
                  return new MapaBaseActions.GetMapaBaseSuccess(Mapa);
              }),
              catchError(error => of (new MapaBaseActions.GetMapaBaseFailure({ error })))
            );
      }));
}